import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
	selector: '[focusDirective]'
})
export class FocusDirective {
	@Output() onFocusOut: EventEmitter<boolean> = new EventEmitter<false>();

	@HostListener('focus', ['$event'])
	public onListenerTriggered(event: any): void {
		this.onFocusOut.emit(true);
	}
}
